import accordion from '@components/accordion';

const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';

// The open category's pane shows in the frame: it fades in and its cards ease up one after another
export default (block) => {
  const items = block.querySelector('.feature-panels-block-items');
  const panes = [...block.querySelectorAll('.feature-panels-block-pane')];

  if (!items) {
    return;
  }

  accordion(items, { keepOne: true });

  items.querySelectorAll('details').forEach((item) => item.addEventListener('toggle', () => {
    if (!item.open) {
      return;
    }

    panes.forEach((pane) => {
      pane.dataset.active = String(pane.dataset.pane === item.dataset.pane);
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const pane = panes.find((candidate) => candidate.dataset.active === 'true');

    pane.animate({
      opacity: [0, 1]
    }, {
      duration: 450,
      easing: EASE
    });
    pane.querySelectorAll('.feature-panels-block-card').forEach((card, i) => card.animate({
      opacity: [0, 1],
      transform: ['translateY(1rem)', 'none']
    }, {
      duration: 500,
      delay: 120 + (i * 90),
      easing: EASE,
      fill: 'backwards'
    }));
  }));
};
